import React, { Fragment, useContext } from "react";
import { PropTypes } from "prop-types";
import DatePicker from "../../../react_utils/DatePicker";
import { Stack, Typography } from "@mui/material";
import ExcelExport from "../../../react_utils/ExcelExport";
import { MessagingContext } from "../../MessagingContext";
import useDailyFlowDownloader from "../../../shared/hooks/flowhistory/useDailyFlowDownloader";
import LocationClient from "../../../shared/api/LocationClient";

export default function DailyFlowDownloader({ defaultDate, locationClient }) {
  const { showMessage } = useContext(MessagingContext);

  const { excelExport, date } = useDailyFlowDownloader(
    defaultDate,
    locationClient,
    showMessage,
  );

  return (
    <Fragment>
      <Typography sx={{ marginBottom: "20px" }}>
        Historie als Exceldatei exportieren:
      </Typography>
      <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
        <DatePicker
          date={date.start.value}
          setDate={date.start.setValue}
          label={"von"}
          views={["year", "month"]}
        />
        {date.start.value && (
          <DatePicker
            date={date.end.value}
            setDate={date.end.setValue}
            minDate={date.end.min}
            maxDate={date.end.max}
            label={"bis"}
            views={["year", "month"]}
          />
        )}
        <ExcelExport
          exporter={excelExport.getData}
          fileName={excelExport.filename}
          disabled={excelExport.disabled}
        />
      </Stack>
    </Fragment>
  );
}

DailyFlowDownloader.propTypes = {
  defaultDate: PropTypes.instanceOf(Date),
  locationClient: PropTypes.instanceOf(LocationClient),
};
